import MiniGameScene from "./MiniGameScene";

import LockDoorAtlasTexture from "../../../assets/atlas/lockTheGateScene.png";
import LockDoorAtlasData from "../../../assets/atlas/lockTheGateScene.json";

import servo from "../../../assets/audio/Robot_Big_Footstep_Servo_003.ogg";
import servoMP3 from "../../../assets/audio/Robot_Big_Footstep_Servo_003.mp3";

import QuestionPopupComponent from "../../components/ncsc/QuestionPopupComponent";
import { PHShape } from "../../plugins/global/PlaceholderPlugin";
import {
  LockTheDoorModel,
  QuestionModel,
} from "../../interfaces/IContentModel";
import { shuffleArrayFY } from "../../plugins/utils/Utils";

export default class LockTheDoorScene extends MiniGameScene {
  topDoor: Phaser.GameObjects.Container;
  bottomDoor: Phaser.GameObjects.Container;
  topTween: Phaser.Tweens.Tween;
  bottomTween: Phaser.Tweens.Tween;
  glowTween: Phaser.Tweens.Tween;
  topBottomY: number[];
  dataModel: LockTheDoorModel;
  questionDifficulty: number;
  enemyDude: Phaser.GameObjects.Image;
  alertGlow: Phaser.GameObjects.Image;
  questionCount: number;
  qPop: QuestionPopupComponent;
  sparkEmitter: Phaser.GameObjects.Particles.ParticleEmitterManager;
  grindEmitter: Phaser.GameObjects.Particles.ParticleEmitter;
  constructor() {
    super({
      key: "LockTheDoorScene",
      active: false,
    });
    console.log("LockTheDoorScene::constructor");
  }

  preload(): void {
    //
    super.preload();
    // this.cameras.main.setBackgroundColor(0x2b2a7d);
   

    this.load.atlas("lock-door-atlas", LockDoorAtlasTexture, LockDoorAtlasData);
    this.load.audio("servo-sound", [servo,servoMP3]);



   
  }

  create(): void {
    super.create();
    console.log("LockTheDoorScene::create");



    this.sponge.placeholder.image(
      this,
      this.cameras.main.centerX,
      this.cameras.main.centerY,
      PHShape.RECT,
      {
        width: this.cameras.main.width,
        height: this.cameras.main.height,
        radius: 0,
      },
      0x2b2a7d
    );

    // this.pauseCam.ignore(bg);

 // this.load.image("randTitle", randTitle);
 const roof = this.add.graphics();
 roof.fillStyle(0x54515f, 1);
 roof.fillRect(0, 160, 720, 140);



 this.dataModel = this.sponge.data.content.lockTheDoorDataModel;
 this.questionCount = 0;
 this.questionDifficulty = this.sponge.data.save.minigameDifficulty;




    // this.cameras.main.setBackgroundColor(0x54515f);
    this.cameras.main.setBackgroundColor(0x2b2a7d);
    this.pauseCam.setBackgroundColor(0x2b2a7d);


    this.enemyDude = this.add
      .image(
        this.cameras.main.centerX,
        this.cameras.main.height,
        "lock-door-atlas",
        "hacker-background.png"
      )
      .setOrigin(0.5, 1);
    
    this.pauseCam.ignore(this.enemyDude);

    this.bottomDoor = this.add.container(
      this.cameras.main.centerX + 80,
      1040 + 20
    );

    this.topDoor = this.add.container(
      this.cameras.main.centerX + 80,
      600 - 20
    );

    const headerBg = this.add.graphics();
    headerBg.fillStyle(0x000000,1);
    headerBg.fillRect(0,0,720,160);

    this.pauseCam.ignore([this.enemyDude,this.topDoor,this.bottomDoor]);

    this.topBottomY = [400, 1240];

    let door = this.add.image(0, 0, "lock-door-atlas", "door-upper.png");
    let fingers = this.add.image(
      -200,
      325,
      "lock-door-atlas",
      "hacker-left-hand.png"
    );

    const complete = this.add.image(
      0,
      223,
      "lock-door-atlas",
      "unlocked-icon.png"
    );
    // complete.setAlpha(0);

    this.topDoor.add([door, fingers, complete]);
    this.topDoor.setData("fingers", fingers);
    this.topDoor.setData("complete", complete);

    door = this.add.image(0, 0, "lock-door-atlas", "door-lower.png");
    fingers = this.add.image(
      200,
      -265,
      "lock-door-atlas",
      "hacker-right-hand.png"
    );

    this.bottomDoor.add([door, fingers]);

    this.bottomDoor.setData("fingers", fingers);

    const controlPanel = this.add
      .image(
        0,
        this.cameras.main.height,
        "lock-door-atlas",
        "control-panel.png"
      )
      .setOrigin(0, 1);

      this.pauseCam.ignore(controlPanel);
   

    const avatar = this.add
      .image(
        0,
        this.cameras.main.height,
        "lock-door-atlas",
        "character-encryptor.png"
      )
      .setOrigin(0, 1);

    const avatarFrame = ["encryptor", "glitch","nano" ][
      this.sponge.data.save.characterSelect
    ];

    avatar.setFrame(`character-${avatarFrame}.png`);

    this.pauseCam.ignore(avatar);


    this.sparkEmitter = this.add.particles("lock-door-atlas",'particle.png');
    this.grindEmitter = this.sparkEmitter.createEmitter({
      alpha: {min: 0.1, max:1},
      scale: {start: 0.75, end: 2},
      lifespan: 2000,
      frequency: 40,
      rotate:5,
      speedX: {min: -100, max:100},
      speedY: {min: 120, max:320},
      maxParticles:0,
      x: 0,
      y: 0
    }) 
    this.grindEmitter.stop();
    

    const fill = this.sponge.placeholder.image(
      this,
      this.cameras.main.centerX,
      0,
      PHShape.RECT,
      {
        width: this.cameras.main.width,
        height: 535,
        radius: 0,
      },
      0x54515f
    );

    this.pauseCam.ignore(fill)

    this.alertGlow = this.add
    .image(
      this.cameras.main.centerY,
      120,
      "alertGlow"
    )
    .setOrigin(0.5, 0);

  this.glowTween = this.tweens.add({
    targets: this.alertGlow,
    alpha: 0,
    duration: 500,
    yoyo: true,
    repeat: -1
  })

    //assign questions bank based on game progress
    // for now just use easy
    // switch to hard after answering first question

    const tempQ1Array = this.choothQuethtionBank(this.dataModel.easyQuestions);
    const tempQ2Array = this.choothQuethtionBank(this.dataModel.medQuestions);
 
    this.qPop = new QuestionPopupComponent(
      this,
      tempQ1Array,
      tempQ2Array,
      "question-complete",
      true
    );

    this.qPop.on("wrongAnswerGiven", this.openDoorMore, this);
    this.qPop.on("showQuestionComponent", this.revealQPop, this);

    this.events.on("question-complete", (correct: boolean) => {
      this.answerAllCorrect(correct);
    });

    this.qPop.setActive(false).setAlpha(0);

    // this.time.delayedCall(3000, () => {
    //   this.answerAllCorrect();
    // });
  }
  start() {
    this.topTween = this.add.tween({
      targets: this.topDoor,
      duration: 1000,
      y: this.topBottomY[0],
      ease: "Bounce.easeOut",
      delay: 1000,
      onUpdate: () => {
        this.sparkEmitter.setPosition(160, this.topDoor.y);
        this.grindEmitter.emitParticle(1,0,0);
        this.grindEmitter.emitParticle(3,560,0);
      }
    });
    this.bottomTween = this.add.tween({
      targets: this.bottomDoor,
      duration: 1000,
      y: this.topBottomY[1],
      ease: "Bounce.easeOut",
      delay: 1000,
      onCompleteScope: this,
      onComplete:this.showQ,
      onStartScope: this,
      onStart:()=>{
        this.cameras.main.shake(1000,0.01);
        this.sound.play("servo-sound", {
          volume: 0.7
        });
      }
    });
  }

  showQ(){
    this.bottomTween = this.add.tween({
      targets: this.qPop,
      duration: 1000,
      alpha: 1,
      ease: "Quad.easeOut",
      delay: 1000,
      onCompleteScope: this,
      onComplete:()=>{
        this.qPop.setActive(true)
        this.qPop.start();
      }
    });
  }

  choothQuethtionBank(tempQArray: QuestionModel[]) {
    const chrisQBank: QuestionModel[] = [];
    
    shuffleArrayFY(tempQArray);
    for (let i: number = 0; i < 5; i++) {
      chrisQBank.push(tempQArray[i]);
    }

    return chrisQBank;
  }

  answerAllCorrect(isCorrect: boolean) {
    this.topBottomY = isCorrect ? [600, 1040] : [0, 1540];
    this.topBottomY[1];
    this.topTween.stop();
    this.bottomTween.stop();
    this.glowTween.stop();
    this.alertGlow.setAlpha(0);
    this.sound.play("servo-sound", {
      volume: 0.7, rate:2
    });
    this.add.tween({
      targets: this.topDoor,
      duration: 200,
      ease: "Quad.easeIn",
      y: this.topBottomY[0],

    });
    this.add.tween({
      targets: this.bottomDoor,
      duration: 200,
      ease: "Quad.easeIn",
      y: this.topBottomY[1],
      onComplete: () => {
        isCorrect ? this.doorComplete() : this.helloJohnny();
      },
    });
  }
  

  revealQPop(){
    this.qPop.setAlpha(1).setActive(true);
  }

  openDoorMore() {
    this.qPop.setAlpha(0).setActive(false);

    this.topBottomY[0] -= 70;
    this.topBottomY[1] += 70;
    this.topTween.stop();
    this.bottomTween.stop();

    this.topTween = this.add.tween({
      targets: this.topDoor,
      duration: 1000,
      y: this.topBottomY[0],
      ease: "Bounce.easeOut",
      onUpdate: () => {
        this.sparkEmitter.setPosition(160, this.topDoor.y);
        this.grindEmitter.emitParticle(1,0,0);
        this.grindEmitter.emitParticle(3,560,-40);
      }
    });
    this.bottomTween = this.add.tween({
      targets: this.bottomDoor,
      duration: 1000,
      y: this.topBottomY[1],
      ease: "Bounce.easeOut",
      onCompleteScope: this,
      onComplete:()=>{
        this.qPop.incorrectAnimationCompleted();
      },
      onStartScope: this,
      onStart:()=>{
        this.cameras.main.shake(1000,0.01);
        this.sound.play("servo-sound", {
          volume: 0.7
        });
      }
    });
  }



  helloJohnny() {
    // show enemy breach
    this.enemyDude.setAlpha(0);
    const redBg = this.add.graphics();
    redBg.fillStyle(0x740818, 0.9);
    redBg.fillRect(0, 160, 720, 1280);

    const nme = this.add
      .image(
        this.cameras.main.centerX + 50,
        this.cameras.main.centerY + 250,
        "lock-door-atlas",
        "hacker-carousel.png"
      )
      .setScale(1.5)
      .setAngle(10);
    this.cameras.main.shake(300, 0.001);
    this.pauseCam.ignore(nme);

    const nmeText = this.add
      .text(
        this.cameras.main.centerX,
        this.cameras.main.centerY,
        this.sponge.data.model.content.strings.tooLate,
        this.sponge.data.model.fonts.question
      )
      .setFontSize(80)
      .setStroke("#000000", 20)
      .setOrigin(0.5)
      .setFill('#FFFFFF')
      .setAngle(-5);


    this.tweens.add({
      targets: nme,
      scale: 3,
      angle: 20,
      y: this.cameras.main.centerY,
      x: this.cameras.main.centerX,
      ease: "Quad.easeIn",
      delay: 750,
      duration: 750,
      onCompleteScope: this,
      onComplete: () => {
        this.complete(0);
      },
    });
  }

  doorComplete() {
    this.cameras.main.shake(300, 0.001);

    const complete: Phaser.GameObjects.Image = this.topDoor.getData("complete");
    complete.setTexture("lock-door-atlas", "locked-icon.png");

    const t: Phaser.GameObjects.Image = this.topDoor.getData("fingers");

    const particles = this.add.particles("lock-door-atlas", "finger.png");

    particles.createEmitter({
      x: t.x + this.topDoor.x,
      y: t.y + this.topDoor.y,
      speed: 500,
      quantity: 1,
      frequency:500,
      maxParticles: 1,
      gravityY: 800,
      rotate: { random: true, start: 0, end: 180 },
      angle: { random: true, start: 0, end: 270 },
    });
    t.destroy();

    const b: Phaser.GameObjects.Image = this.bottomDoor.getData("fingers");
    particles.createEmitter({
      x: b.x + this.bottomDoor.x,
      y: b.y + this.bottomDoor.y,
      speed: 500,
      quantity: 1,

      maxParticles: 1,
      gravityY: 800,
      rotate: { random: true, start: 0, end: 180 },
      angle: { random: true, start: 0, end: 270 },
    });
    t.destroy();

    b.destroy();

    const c: Phaser.GameObjects.Image = this.topDoor.getData("complete");
    c.setAlpha(1);

    this.time.delayedCall(1000, () => {
      this.complete(1);
    });
  }

  // showFeedback() {
  //   switch (this.passwordStrength) {
  //     case 1:
  //       // show Positive feedback from model
  //       this.complete(1);
  //       this.shutdown();
  //       break;
  //     default:
  //       // show Negative feedback from model
  //       this.complete(0);
  //       this.shutdown();
  //       break;
  //   }
  // }

  update(time: number, delta: number): void {
    //
  }

  shutdown(): void {
    //call our minigame complete method
    super.shutdown();
  }
}
